import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomModal from "../ui/modal/modal.component";
import CreateShipmentForm from "./createShipmentForm.component";
import { Shipment } from "../../types/shipping";

interface SendByCourierModalProps {
  opened: boolean;
  setOpened: (opened: boolean) => void;
  initialPart?: { id: number | string; name: string; stock_quantity?: string; unit?: string } | null;
}

/** "Send by courier" - the same dialog from the stock list, a part's page and
 * the shipments list. Mounted only while open, so it always starts afresh. */
export const SendByCourierModal = ({ opened, setOpened, initialPart }: SendByCourierModalProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!opened) return null;

  const handleSuccess = (shipment: Shipment) => {
    setOpened(false);
    // The parts left stock with the order.
    window.dispatchEvent(new Event("partUpdated"));
    window.dispatchEvent(new Event("usedPartAdded"));
    window.dispatchEvent(new Event("shipmentAdded"));
    navigate(`/service/shipments/${shipment.id}`);
  };

  return (
    <CustomModal
      opened={opened}
      setOpened={setOpened}
      title={t("Send by courier")}
      content={<CreateShipmentForm initialPart={initialPart} onSuccess={handleSuccess} />}
    />
  );
};
